export default function PersonalizationDivider() {
    return <hr
        style={{
            marginLeft: "-40px",
            marginRight: "-40px",
            width: "calc(100% + 80px)"
        }}
    />
}